export default __webpack_public_path__ + "static/media/arena-football.967a67cb.svg";